// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__22XkX","footer":"ModalError_footer__2aO1k"};